import React from "react";

import ScenarioFinancingAnalysis from
  "../../../components/risk_financing/scenario/ScenarioFinancingAnalysis";

import useRiskFinancingContext from
  "../context/useRiskFinancingContext";
import { useAccess } from "../../../access/AccessContext";
import { PERMISSIONS } from "../../../access/capabilities";


export default function RiskFinancingScenarioTab({
  settings,
}) {
    const access = useAccess();


    const {
        scenario,
    } = useRiskFinancingContext();

    const {
        list,
        selectedId,
        strategy,
        analysis,

        state,

        actions,
    } = scenario;

  return (
    <ScenarioFinancingAnalysis
    scenarios={list}
    selectedScenarioId={selectedId}
    strategy={strategy}
    data={analysis}
    settings={settings}

    scenariosLoading={state.listLoading}
    analysisLoading={state.analysisLoading}

    scenariosError={state.listError}
    analysisError={state.analysisError}

    onScenarioChange={
        actions.select
    }

    onStrategyChange={
        actions.changeStrategy
    }

    onAnalyze={access.hasPermission(PERMISSIONS.financing.execute) ? actions.analyze : undefined}

    onCompareAlternatives={access.hasPermission(PERMISSIONS.financing.execute) ? actions.compareAlternatives : undefined}
    />
  );
}
